import { logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { getAnalyticsIfSupported } from '../../firebase';
import { hasAnalyticsConsent } from '../../utils/cookieConsent';

const getConsentedAnalytics = async () => {
  if (!hasAnalyticsConsent()) return null;
  return getAnalyticsIfSupported();
};

export const trackPageView = async (path, title = document.title) => {
  const analytics = await getConsentedAnalytics();
  if (!analytics) return;

  logEvent(analytics, 'page_view', {
    page_path: path,
    page_title: title,
    page_location: window.location.href,
  });
};

export const trackEvent = async (eventName, params = {}) => {
  const analytics = await getConsentedAnalytics();
  if (!analytics) return;

  logEvent(analytics, eventName, params);
};

export const setAnalyticsUser = async (userId, properties = {}) => {
  const analytics = await getConsentedAnalytics();
  if (!analytics) return;

  if (userId) {
    setUserId(analytics, String(userId));
  }

  if (Object.keys(properties).length > 0) {
    setUserProperties(analytics, properties);
  }
};

export const clearAnalyticsUser = async () => {
  const analytics = await getConsentedAnalytics();
  if (!analytics) return;

  setUserId(analytics, null);
};
